import React from 'react';
import PropTypes from 'prop-types';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import { dataAttrs } from 'Helpers/Testing';

const ListItemRemoveDialog = ({
  dialogOpen,
  dialogProps,
  loading,
  handleClose,
  handleSubmit,
}) => {
  const {
    title,
    message,
    cancelLabel,
    confirmLabel,
  } = dialogProps;

  if (!dialogOpen) {
    return null;
  }

  return (
    <NewDialog
      title={title}
      message={message}
      cancelLabel={cancelLabel}
      confirmLabel={confirmLabel}
      confirmButtonType="error"
      loading={loading}
      onConfirm={handleSubmit}
      onCancel={(e) => {
        handleClose(e);
      }}
      onClose={() => {
        handleClose();
      }}
      showCloseIcon={false}
      {...dataAttrs('list-item-remove-dialog')}
    />
  );
};

ListItemRemoveDialog.defaultProps = {
  dialogOpen: false,
  dialogProps: {},
  loading: false,
};

ListItemRemoveDialog.propTypes = {
  dialogOpen: PropTypes.bool,
  dialogProps: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ListItemRemoveDialog;
